/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mk_Cmp_Cta_OneInputs */

const en_mk_cmp_cta_one = /** @type {(inputs: Mk_Cmp_Cta_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vs ${i?.name}`)
};

const id_mk_cmp_cta_one = /** @type {(inputs: Mk_Cmp_Cta_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vs ${i?.name}`)
};

/**
* | output |
* | --- |
* | "vs {name}" |
*
* @param {Mk_Cmp_Cta_OneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_cta_one = /** @type {((inputs: Mk_Cmp_Cta_OneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Cta_OneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_cta_one(inputs)
	return en_mk_cmp_cta_one(inputs)
});